module.exports = __webpack_public_path__ + "static/media/19ESCAP49.262391ae.jpg";